module.exports = __webpack_public_path__ + "static/media/welcomhome-oc-horizontal.5d0cb039.svg";